module.exports = __webpack_public_path__ + "static/media/rslogogif.06670765.gif";